"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = exports.EducationLevel = void 0;
var NumItems;
(function (NumItems) {
    NumItems["NONE"] = "NONE";
    NumItems["ONE"] = "ONE";
    NumItems["TWO"] = "TWO";
    NumItems["THREE"] = "THREE";
    NumItems["FOUR_MORE"] = "FOUR_MORE";
})(NumItems || (NumItems = {}));
var OriginOfWater;
(function (OriginOfWater) {
    OriginOfWater["GENERAL"] = "GENERAL";
    OriginOfWater["SOURCE"] = "SOURCE";
    OriginOfWater["OTHER"] = "OTHER";
})(OriginOfWater || (OriginOfWater = {}));
var TypeOfStreet;
(function (TypeOfStreet) {
    TypeOfStreet["ASPHALT"] = "ASPHALT";
    TypeOfStreet["GRAVEL"] = "GRAVEL";
})(TypeOfStreet || (TypeOfStreet = {}));
var VolunteerDescription;
(function (VolunteerDescription) {
    VolunteerDescription["PF_DONATION"] = "PF_DONATION";
    VolunteerDescription["PJ_DONATION"] = "PJ_DONATION";
    VolunteerDescription["PJ_JOB"] = "PJ_JOB";
    VolunteerDescription["OTHER"] = "OTHER";
})(VolunteerDescription || (VolunteerDescription = {}));
var DifficultiesProgramming;
(function (DifficultiesProgramming) {
    DifficultiesProgramming["INSERTION_WORK"] = "INSERTION_WORK";
    DifficultiesProgramming["ORGANIZATION_STUDY"] = "ORGANIZATION_STUDY";
    DifficultiesProgramming["APROPRIATED_LOCAL"] = "APROPRIATED_LOCAL";
    DifficultiesProgramming["INSECURITY"] = "INSECURITY";
    DifficultiesProgramming["SUPPORT_NETWORK"] = "SUPPORT_NETWORK";
    DifficultiesProgramming["GUIDANCE"] = "GUIDANCE";
    DifficultiesProgramming["ACCESSIBLE_COURSE"] = "ACCESSIBLE_COURSE";
    DifficultiesProgramming["OVERLOADED"] = "OVERLOADED";
    DifficultiesProgramming["APPLY_PRACTICE"] = "APPLY_PRACTICE";
    DifficultiesProgramming["TIME"] = "TIME";
    DifficultiesProgramming["ANXIETY"] = "ANXIETY";
    DifficultiesProgramming["SELF_MOTIVATION"] = "SELF_MOTIVATION";
    DifficultiesProgramming["ENGLISH"] = "ENGLISH";
    DifficultiesProgramming["PROGRAMMING"] = "PROGRAMMING";
})(DifficultiesProgramming || (DifficultiesProgramming = {}));
var Level;
(function (Level) {
    Level["NONE"] = "NONE";
    Level["INTRODUCTORY"] = "INTRODUCTORY";
    Level["BASIC"] = "BASIC";
    Level["INTERMEDIARY"] = "INTERMEDIARY";
    Level["ADVANCED"] = "ADVANCED";
})(Level || (Level = {}));
var EmployabilitySituation;
(function (EmployabilitySituation) {
    EmployabilitySituation["CLT"] = "CLT";
    EmployabilitySituation["PJ"] = "PJ";
    EmployabilitySituation["FREELANCER"] = "FREELANCER";
    EmployabilitySituation["ENTREPRENEUR"] = "ENTREPRENEUR";
    EmployabilitySituation["TREINEE"] = "TREINEE";
    EmployabilitySituation["SCHOLARSHIP"] = "SCHOLARSHIP";
    EmployabilitySituation["UNEMPLOYED"] = "UNEMPLOYED";
})(EmployabilitySituation || (EmployabilitySituation = {}));
var UnemployedTime;
(function (UnemployedTime) {
    UnemployedTime["ONE_MONTH"] = "ONE_MONTH";
    UnemployedTime["THREE_MONTH"] = "THREE_MONTH";
    UnemployedTime["SIX_MONTH"] = "SIX_MONTH";
    UnemployedTime["ONE_YEAR"] = "ONE_YEAR";
    UnemployedTime["MORE_ONE_YEAR"] = "MORE_ONE_YEAR";
})(UnemployedTime || (UnemployedTime = {}));
var EducationLevel;
(function (EducationLevel) {
    EducationLevel["INCOMPLETE_ELEMENTARY_SCHOOL"] = "INCOMPLETE_ELEMENTARY_SCHOOL";
    EducationLevel["COMPLETE_ELEMENTARY_SCHOOL"] = "COMPLETE_ELEMENTARY_SCHOOL";
    EducationLevel["INCOMPLETE_HIGH_SCHOOL"] = "INCOMPLETE_HIGH_SCHOOL";
    EducationLevel["COMPLETE_HIGH_SCHOOL"] = "COMPLETE_HIGH_SCHOOL";
    EducationLevel["INCOMPLETE_TECHNICAL_COURSE"] = "INCOMPLETE_TECHNICAL_COURSE";
    EducationLevel["TECHNICAL_COURSE_IN_PROGRESS"] = "TECHNICAL_COURSE_IN_PROGRESS";
    EducationLevel["COMPLETE_TECHNICAL_COURSE"] = "COMPLETE_TECHNICAL_COURSE";
    EducationLevel["INCOMPLETE_COLLEGE_EDUCATION"] = "INCOMPLETE_COLLEGE_EDUCATION";
    EducationLevel["COLLEGE_EDUCATION_IN_PROGRESS"] = "COLLEGE_EDUCATION_IN_PROGRESS";
    EducationLevel["COMPLETE_COLLEGE_EDUCATION"] = "COMPLETE_COLLEGE_EDUCATION";
    EducationLevel["ESPECIALIZATION"] = "ESPECIALIZATION";
    EducationLevel["MASTER"] = "MASTER";
    EducationLevel["DOCTORATE"] = "DOCTORATE";
})(EducationLevel = exports.EducationLevel || (exports.EducationLevel = {}));
var Status;
(function (Status) {
    Status["APPROVED"] = "APPROVED";
    Status["DISAPPROVED"] = "DISAPPROVED";
    Status["IN_PROCESS"] = "IN_PROCESS";
    Status["NONE"] = "NONE";
    Status["PENDING"] = "PENDING";
    Status["WAITING_LIST"] = "WAITING_LIST";
    Status["ACTIVE"] = "ACTIVE";
})(Status || (Status = {}));
exports.enums = {
    numItems: NumItems,
    originOfWater: OriginOfWater,
    typeOfStreet: TypeOfStreet,
    volunteerDescription: VolunteerDescription,
    difficultiesProgramming: DifficultiesProgramming,
    level: Level,
    employabilitySituation: EmployabilitySituation,
    unemployedTime: UnemployedTime,
    educationLevel: EducationLevel,
    status: Status,
};
//# sourceMappingURL=ClassVacancySubscription.js.map